var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c6561a6ef0cdb61fe20187602f9423942f3d3566"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["docupet-app-login@docupet"]={id:"c6561a6ef0cdb61fe20187602f9423942f3d3566"};
      